module.exports = __webpack_public_path__ + "img/retinexsf.c6d81b8f.png";